@if(highlightsList?.length > 0) {
<div>

  @if(calledFrom != 'my-candidates' && calledFrom != 'project-upload-candidates' && calledFrom != 'project-inbound-applications') {
  <span>
    <svg xmlns="http://www.w3.org/2000/svg" class="mr-2" width="14" height="13" viewBox="0 0 14 13" fill="none">
      <path
        d="M6.68659 10.7006L3.44517 12.6532C3.30198 12.7444 3.15228 12.7834 2.99606 12.7704C2.83985 12.7574 2.70316 12.7053 2.586 12.6142C2.46884 12.5231 2.37772 12.4093 2.31263 12.2729C2.24754 12.1364 2.23453 11.9833 2.27358 11.8136L3.13275 8.12306L0.26234 5.64318C0.132163 5.52603 0.0509325 5.39246 0.0186485 5.2425C-0.0136354 5.09253 -0.00400237 4.94622 0.0475478 4.80354C0.099098 4.66087 0.177204 4.54371 0.281867 4.45206C0.386529 4.36042 0.529724 4.30184 0.711452 4.27632L4.49961 3.94437L5.9641 0.468638C6.02919 0.312426 6.13021 0.195266 6.26716 0.117159C6.4041 0.0390531 6.54391 0 6.68659 0C6.82926 0 6.96907 0.0390531 7.10602 0.117159C7.24297 0.195266 7.34398 0.312426 7.40907 0.468638L8.87357 3.94437L12.6617 4.27632C12.844 4.30236 12.9872 4.36094 13.0913 4.45206C13.1955 4.54319 13.2736 4.66035 13.3256 4.80354C13.3777 4.94674 13.3876 5.09332 13.3553 5.24328C13.323 5.39324 13.2415 5.52655 13.1108 5.64318L10.2404 8.12306L11.0996 11.8136C11.1386 11.9828 11.1256 12.1359 11.0605 12.2729C10.9955 12.4098 10.9043 12.5236 10.7872 12.6142C10.67 12.7048 10.5333 12.7569 10.3771 12.7704C10.2209 12.7839 10.0712 12.7449 9.928 12.6532L6.68659 10.7006Z"
        fill="#969696" />
    </svg> <span class="f-12 font-weight-500 text-black">Highlights</span>
  </span>
  }
</div>
@if(calledFrom != 'my-candidates' && calledFrom != 'project-upload-candidates' && calledFrom != 'project-inbound-applications') {
<div class="highlight-chip-container mb-3">
  @for(highlight of highlightsList; track highlight.label) {
  <div class="highlight-chips"  [ngbTooltip]="highlight_chip_tooltip" placement="bottom">
    <i class="fa-solid fa-building mr-2" [ngClass]="'briefcase-blank-' + highlight.color"
      *ngIf="!highlight?.imageName"></i>
    <span *ngIf="highlight?.imageName">
      <img [src]="'assets/highlights/' + highlight.imageName + '.svg'" alt="">
    </span>
    <span>{{ highlight.label }}</span>
    <ng-template #highlight_chip_tooltip>
      <span class=" f-12">
        <span class="">

          <div
            *ngIf="highlight.label !== 'Multi-Industry' && highlight.label !== 'Techie' && highlight.label !== 'Promotion Track' && highlight.label !== 'Unicorn Experience'
                                                    && highlight.label !== 'Same Location' && highlight.label !== 'Nearby Location' && highlight.label !== 'Role Compatibility'
                                                    && highlight.label !== 'Years of Experience' && highlight.label !== 'Company Size' && highlight.label !== 'Skills Matched'">
            <div class="hiderule">
              <div class="position-relative">
                <span class="dot custom-tooltip"></span>
                <span class="font-weight-normal f-12 hl-mssg custom-tooltip">
                  Candidate has {{ highlight.label.toLowerCase() }} :
                  <span class="f-12 font-weight-600 fw-600" *ngFor="let item of highlight.value; let last = last">
                    {{ item | titlecase }}{{ !last ? ', ' : '.' }}
                  </span>
                </span>
              </div>
              <hr class="highlight-tooltip-divider custom-tooltip">
            </div>
          </div>

          <div *ngIf="highlight.label === 'Techie'">
            <div class="hiderule">
              <div class="position-relative">
                <span class="dot custom-tooltip"></span>
                <span class="font-weight-normal f-12 hl-mssg custom-tooltip">
                  Activity noticed on technology social networks like: GitHub, Stack Overflow,
                  Kaggle, etc.
                </span>
              </div>
              <hr class="highlight-tooltip-divider custom-tooltip">
            </div>
          </div>

          <div *ngIf="highlight.label === 'Multi-Industry'">
            <div class="hiderule" *ngFor="let item of highlight.value">
              <div class="position-relative">
                <span class="dot custom-tooltip"></span>
                <span class="font-weight-normal f-12 hl-mssg custom-tooltip text-capitalize">Worked in <span class="fw-600">{{item.name}}</span>
                  <span class="font-weight-normal f-12" *ngIf="item.exp.year || item.exp.month"> for </span>
                  <span class="font-weight-normal f-12" *ngIf="item.exp.year">{{(item.exp.year
                    == 1)? (item.exp.year +" Year"):(item.exp.year+" Years")}} </span>
                  <span class="font-weight-normal f-12" *ngIf="item.exp.year && item.exp.month">and </span>
                  <span class="font-weight-normal f-12" *ngIf="item.exp.month">{{(item.exp.month == 1)?
                    (item.exp.month +"
                    Month"):(item.exp.month+" Months")}} </span>
                </span>
              </div>
              <hr class="highlight-tooltip-divider custom-tooltip">
            </div>
          </div>

          <div *ngIf="highlight.label === 'Promotion Track'">
            <div class="hiderule">
              <div class="position-relative"
                *ngIf="highlight.value?.progression_within_pastcompany && highlight.value?.currentjob_internal_movement">
                <span class="dot custom-tooltip"></span>
                <span class="font-weight-normal f-12 hl-mssg custom-tooltip">Promoted at both current and previous
                  companies.</span>
              </div>
              <div class="position-relative"
                *ngIf="highlight.value?.currentjob_internal_movement && !(highlight.value?.progression_within_pastcompany && highlight.value?.currentjob_internal_movement)">
                <span class="dot custom-tooltip"></span>
                <span class="font-weight-normal f-12 hl-mssg custom-tooltip">Promoted at current company.</span>
              </div>
              <div class="position-relative"
                *ngIf="highlight.value?.progression_within_pastcompany && !(highlight.value?.progression_within_pastcompany && highlight.value?.currentjob_internal_movement)">
                <span class="dot custom-tooltip"></span>
                <span class="font-weight-normal f-12 hl-mssg custom-tooltip">Promoted at previous company.</span>
              </div>
            </div>
          </div>

          <div *ngIf="highlight.label === 'Unicorn Experience'">
            <div class="hiderule">
              <div class="position-relative">
                <span class="dot custom-tooltip"></span>
                <span class="font-weight-normal f-12 hl-mssg">
                  Candidate has experience in a Unicorn company :
                  <span class="f-12 font-weight-600 fw-600" *ngFor="let item of highlight.value; let last = last">
                    {{ capitalizeFirstLetter(item) }}{{ !last ? ', ' : '.' }} </span>
                </span>
              </div>
              <hr class="highlight-tooltip-divider custom-tooltip">
            </div>
          </div>

          <div *ngIf="highlight.label === 'Same Location' || highlight.label === 'Nearby Location'">
            <div class="hiderule">
              <div>
                <span class="font-weight-normal f-12 hl-mssg custom-tooltip"> This Candidate’s current location
                  <span class="text-capitalize" [innerHTML]="highlight.value"></span>
                  matches with your ideal profile.
                </span>
              </div>
              <hr class="highlight-tooltip-divider custom-tooltip">
            </div>
          </div>

          <div *ngIf="highlight.label === 'Role Compatibility' || highlight.label === 'Years of Experience'">
            <div class="hiderule">
              <div>
                <span *ngIf="highlight.label === 'Role Compatibility'" class="font-weight-normal f-12 hl-mssg">The
                  candidate's
                  job
                  title as a <span class="font-weight-600 text-capitalize" [innerHTML]="highlight.titles"></span> aligns
                  with a
                  closely matching
                  profile.
                </span>

                <span *ngIf="highlight.label === 'Years of Experience'" class="font-weight-normal f-12 hl-mssg">The
                  candidate
                  possesses over <span [innerHTML]="totalTenure"></span> years of
                  experience, which
                  closely aligns with your preferred profile.
                </span>

              </div>
              <hr class="highlight-tooltip-divider custom-tooltip">
            </div>
          </div>

          <div *ngIf="highlight.label === 'Company Size' || highlight.label === 'Skills Matched'">
            <div class="hiderule">
              <div>

                <span *ngIf="highlight.label === 'Company Size'" class="font-weight-normal f-12 hl-mssg"> This
                  candidates
                  has
                  worked in a
                  similar company size i.e. <span [innerHTML]="highlight.value"></span> in
                  the past.
                </span>

                <span *ngIf="highlight.label === 'Skills Matched'" class="font-weight-normal f-12 hl-mssg"> <span
                    class="text-capitalize" [innerHTML]="highlights.skills"></span>
                  skills present in this candidate that matches with your ideal profile.
                </span>
              </div>
              <hr class="highlight-tooltip-divider custom-tooltip">
            </div>
          </div>

        </span>
      </span>
    </ng-template>
  </div>
  }
</div>
}
}
@if(candidate?.headline) {
<div class="d-flex mb-3 align-items-center">
  <span>
    <svg xmlns="http://www.w3.org/2000/svg" class="mr-2" width="14" height="14" viewBox="0 0 14 14" fill="none">
      <path fill-rule="evenodd" clip-rule="evenodd"
        d="M6.66667 1.33333C5.73385 1.33316 4.81729 1.57766 4.00848 2.04242C3.19968 2.50718 2.52692 3.17595 2.05735 3.98197C1.58778 4.78799 1.33783 5.70308 1.33245 6.63589C1.32707 7.5687 1.56644 8.48661 2.02667 9.298C2.33775 8.89372 2.73763 8.56639 3.1954 8.34132C3.65317 8.11625 4.15657 7.99947 4.66667 8H8.66667C9.17678 7.99947 9.68018 8.11625 10.138 8.34132C10.5957 8.56639 10.9956 8.89372 11.3067 9.298C11.7669 8.48661 12.0063 7.5687 12.0009 6.63589C11.9955 5.70308 11.7456 4.78799 11.276 3.98197C10.8064 3.17595 10.1337 2.50718 9.32486 2.04242C8.51606 1.57766 7.5995 1.33316 6.66667 1.33333ZM11.962 10.7173C12.0456 10.6084 12.1256 10.4969 12.202 10.3827C12.9411 9.28446 13.3351 7.99041 13.3333 6.66667C13.3333 2.98467 10.3487 0 6.66667 0C2.98467 0 6.83697e-06 2.98467 6.83697e-06 6.66667C-0.00209405 8.13117 0.480033 9.55529 1.37134 10.7173L1.36801 10.7293L1.60467 11.0047C2.22993 11.7357 3.00626 12.3224 3.88016 12.7244C4.75406 13.1264 5.70474 13.3342 6.66667 13.3333C6.81067 13.3333 6.95378 13.3289 7.09601 13.32C8.29894 13.2441 9.45846 12.842 10.45 12.1567C10.9242 11.8295 11.354 11.4423 11.7287 11.0047L11.9653 10.7293L11.962 10.7173ZM6.66667 2.66667C6.13624 2.66667 5.62753 2.87738 5.25246 3.25245C4.87739 3.62753 4.66667 4.13623 4.66667 4.66667C4.66667 5.1971 4.87739 5.70581 5.25246 6.08088C5.62753 6.45595 6.13624 6.66667 6.66667 6.66667C7.19711 6.66667 7.70581 6.45595 8.08089 6.08088C8.45596 5.70581 8.66667 5.1971 8.66667 4.66667C8.66667 4.13623 8.45596 3.62753 8.08089 3.25245C7.70581 2.87738 7.19711 2.66667 6.66667 2.66667Z"
        fill="#969696" />
    </svg>
  </span>
  <span class="f-12 font-weight-500  text-black">
    Key Introduction
  </span>
</div>

<div class="f-12 mb-3">
  {{candidate?.headline}}
</div>
}
@if(candidate?.summary) {
<div class="d-flex mb-3 align-items-center">
  <span class="mr-2">
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M11.5558 15.1787H4.44441C3.05812 15.1787 2.36841 14.4755 2.36841 13.0827V7.00239H7.21669C8.07384 7.00239 8.47555 6.59382 8.47555 5.73668V0.821533H11.5558C12.9353 0.821533 13.6318 1.53125 13.6318 2.92439V13.0827C13.6318 14.4821 12.9353 15.1787 11.5558 15.1787ZM7.19641 6.08496H2.44212C2.48898 5.81039 2.68326 5.54239 2.99784 5.21439L6.69441 1.45782C7.00241 1.13639 7.28355 0.942105 7.56498 0.894962V5.72353C7.56498 5.96439 7.43755 6.08496 7.19641 6.08496ZM10.5781 9.90211C10.8527 9.90211 11.047 9.70782 11.047 9.44668C11.047 9.18525 10.8527 8.99125 10.5784 8.99125H5.41555C5.14755 8.99125 4.93984 9.18553 4.93984 9.44639C4.93984 9.70782 5.14755 9.90182 5.41526 9.90182L10.5781 9.90211ZM10.5781 12.4532C10.8527 12.4532 11.047 12.259 11.047 11.9978C11.047 11.7367 10.8527 11.5424 10.5784 11.5424H5.41555C5.14755 11.5424 4.93984 11.7367 4.93984 11.9978C4.93984 12.259 5.14755 12.4532 5.41526 12.4532H10.5781Z"
        fill="#969696" />
    </svg>
  </span>
  <span class="f-12 font-weight-500  text-black">
    Summary
  </span>
</div>
<div class="f-12 mb-3" [innerHtml]="highlightInfo(candidate?.summary)"></div>
}
